import TochiShaderChunk from "./TochiShaderChunk";

export const ColorLerpChunk: TochiShaderChunk = {
  name: "colorlerp",
  uniforms: {},
  vertexShader: {},
  fragmentShader: {
    premain: `
      
        // Constant index expressions for WebGL 1.0 support
        // https://stackoverflow.com/questions/19529690/index-expression-must-be-constant-webgl-glsl-error
        
        vec3 getColor(vec3 colors[numColors], int num) {
          for (int i=0; i<numColors; i++) {
            if (i==num) {
              return colors[i];
            }
          }
          return colors[0];
        } 

        float getColorPos(float colorPos[numColors], int num) {
          for (int i=0; i<numColors; i++) {
            if (i==num) {
              return colorPos[i];
            }
          }
          return colorPos[0];
        }

        vec3 color_lerp(vec3 colors[numColors], float colorPos[numColors], int len, float t, int i) {

            if (len==1) {
                return colors[0];
            }

            float prev = getColorPos(colorPos, i-1);
            float curr = getColorPos(colorPos, i);
            float next = getColorPos(colorPos, i+1);
            float pct = 0.;
            
            // adjust ends
            if (i==0 && t <= curr) {
                pct = 1.;
            } else if (i==len-1 && curr <= t) {
                pct = 1.;
            }
            
            // if t is between prev and curr
            if (prev < t && t <= curr) {
                pct = (t-prev)/(curr-prev);
            }
            // if t is between curr and next
            else if (curr < t && t < next) {
                pct = (next-t)/(next-curr);
            }
            vec3 ret = mix(vec3(0.,0.,0.), getColor(colors, i), pct);
            return ret;
        }
    `,
  },
};
